import React from "react";
import ArtistLocationSearch from "components/artists/ArtistLocationSearch";
import ArtistSearch from "components/artists/ArtistSearch";

const ARTIST_PROMPT_KEY = 'inkvoyd_artist_prompt_dismissed';

const UserHomePage: React.FC = () => {
    const handleBecomeArtist = () => {
        localStorage.removeItem(ARTIST_PROMPT_KEY);
        window.location.reload();
    };

    const wasDismissed = localStorage.getItem(ARTIST_PROMPT_KEY) === 'true';

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-4xl">
                <h1 className="text-3xl font-bold mb-6 text-center">Coming Soon</h1>
                <ArtistSearch></ArtistSearch>
                <ArtistLocationSearch></ArtistLocationSearch>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className="bg-blue-500 text-white p-6 rounded-lg shadow-md hover:bg-blue-700 transition duration-300">
                        <h2 className="text-xl font-bold mb-2">Artists Near You</h2>
                        <p>Discover talented artists in your area.</p>
                    </div>
                    <div className="bg-green-500 text-white p-6 rounded-lg shadow-md hover:bg-green-700 transition duration-300">
                        <h2 className="text-xl font-bold mb-2">Artist Flash Sales</h2>
                        <p>Get exclusive deals and discounts from your favorite artists.</p>
                    </div>
                    <div className="bg-purple-500 text-white p-6 rounded-lg shadow-md hover:bg-purple-700 transition duration-300">
                        <h2 className="text-xl font-bold mb-2">Your Upcoming Appointments</h2>
                        <p>Keep track of your scheduled tattoo sessions.</p>
                    </div>
                    <div className="bg-red-500 text-white p-6 rounded-lg shadow-md hover:bg-red-700 transition duration-300">
                        <h2 className="text-xl font-bold mb-2">Top Artists</h2>
                        <p>Explore the top-rated tattoo artists in the community.</p>
                    </div>
                    <div className="bg-yellow-500 text-white p-6 rounded-lg shadow-md hover:bg-yellow-700 transition duration-300">
                        <h2 className="text-xl font-bold mb-2">Best Rated Tattoos</h2>
                        <p>Check out the highest-rated tattoos and get inspired.</p>
                    </div>
                    <div className="bg-indigo-500 text-white p-6 rounded-lg shadow-md hover:bg-indigo-700 transition duration-300">
                        <h2 className="text-xl font-bold mb-2">Tattoo Aftercare</h2>
                    </div>
                </div>

                {wasDismissed && (
                    <div className="mt-8 pt-6 border-t border-gray-200 text-center">
                        <button
                            type="button"
                            onClick={handleBecomeArtist}
                            className="text-sm text-orange-600 hover:text-orange-700 hover:underline font-medium transition-colors"
                        >
                            Become an artist?
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserHomePage;